import { render, staticRenderFns } from "./app-link.vue?vue&type=template&id=8436a452"
import script from "./app-link.vue?vue&type=script&lang=js"
export * from "./app-link.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports